import React, { useEffect } from "react";
import Aos from "aos";
import { NavLink } from "react-router-dom";
import row11 from "../image/grow11.jpg";
import grow22 from "../image/grow22.jpg";
import grow14 from "../image/grow14.jpg";
import grow23 from "../image/grow23.jpg";
import grow24 from "../image/grow24.jpg";
import grow31 from "../image/grow31.jpg";
import gbts1 from "../image/gbts1.webp";
import gbts2 from "../image/gbts2.jpg";
import grow32 from "../image/grow32.jpg";
import grow33 from "../image/grow33.jpg";
import grow41 from "../image/grow41.jpg";
import grow42 from "../image/grow42.jpg";
import grow411 from "../image/grow411.jpg";
import grow43 from "../image/grow43.jpg";
import grow44 from "../image/grow44.jpg";
import grow51 from "../image/grow51.jpg";
import grow511 from "../image/grow511.avif";
import grow52 from "../image/grow52.jpg";
import grow522 from "../image/grow522.png";
import grow53 from "../image/grow53.webp";
import grow533 from "../image/grow533.jpg";
import grow54 from "../image/grow54.jpg";
import grow544 from "../image/grow544.jpg";
import grow61 from "../image/grow61.jpg";
import grow62 from "../image/grow62.jpg";
import grow63 from "../image/grow63.png";
import grow64 from "../image/grow64.png";
import grow644 from "../image/grow644.png";
import newg1 from '../image/newg1.jpg'
import newg2 from '../image/newg2.jpg'
import newg3 from '../image/newg3.jpg'
import newg4 from '../image/newg4.jpg'
import newg5 from '../image/newg5.jpg'
import newg6 from '../image/newg6.jpg'
import newg7 from '../image/newg7.jpg'
import newg8 from '../image/newg8.jpg'
import newg9 from '../image/newg9.jpg'
import newg10 from '../image/newg10.jpg'
import newg11 from '../image/newg11.jpg'
import newg12 from '../image/newg12.jpg'
import BackToTop from "./BackToTop";

const Gallery = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden">
      <ol
        className="flex items-center whitespace-nowrap min-w-0 p-2 "
        aria-label="Breadcrumb"
      >
        <li className="text-sm">
          <NavLink to={"/"}>
            {" "}
            <a
              className="flex items-center text-gray-500 hover:text-blue-600"
              href="#"
            >
              <svg
                className="flex-shrink-0 mr-3 h-4 w-4 text-gray-600 dark:text-gray-600"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                />
              </svg>
              Home
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </a>{" "}
          </NavLink>
        </li>
        <NavLink to={"/gallery"}>
          {" "}
          <li className="text-sm">
            <a
              className="flex items-center text-gray-500 hover:text-blue-600"
              href="#"
            >
              <svg
                className="flex-shrink-0 mr-3 h-4 w-4 text-gray-600 dark:text-gray-600"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
                <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
              </svg>
              Gallery
            </a>
          </li>{" "}
        </NavLink>
      </ol>

      {/* <!-- Card Blog --> */}
      <div className="max-w-[85rem] px-3 py-4 sm:px-6 lg:px-5 lg:py-5 mx-auto">
        {/* <!-- Title --> */}
        <div className="max-w-2xl mb-10">
          <h2 className="text-2xl font-bold md:text-4xl md:leading-tight text-gray-800">
            Customer stories
          </h2>
          <p className="mt-1">
            See how game-changing companies are making the most of every
            engagement with BTS Store.
          </p>
        </div>
        {/* <!-- End Title --> */}

        {/* <!-- Grid --> */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 -mt-6">
          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src="https://hcdn.picsart.com/339284596052900.jpg?to=crop&type=webp&r=1456x2242&q=85"
                alt="Image Description"
              />
            </div>
            <h3
              className="mt-2 text-lg font-medium text-gray-800 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white"
              data-hs-overlay="#hs-scroll-inside-body-modal"
            >
              Unity's inside sales team drives 80% of its revenue with BTS Army
              Store.
            </h3>

            <div
              id="hs-scroll-inside-body-modal"
              className="hs-overlay hidden w-full h-full fixed top-0 start-0 z-[60] overflow-x-hidden overflow-y-auto"
            >
              <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto h-[calc(100%-3.5rem)]">
                <div className="max-h-full overflow-hidden flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                  <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                    <h3 className="font-bold text-gray-800 dark:text-white">
                      Unity's inside sales team drives 80% of its revenue with
                      BTS Army Store.
                    </h3>
                    <button
                      type="button"
                      className="flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                      data-hs-overlay="#hs-scroll-inside-body-modal"
                    >
                      <span className="sr-only">Close</span>
                      <svg
                        className="flex-shrink-0 w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="p-4 overflow-y-auto">
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                          BTS is the biggest K-pop group in the world. People
                          just can't get enough, especially online.
                        </h3>
                        <p className="mt-1 text-gray-800 dark:text-gray-400">
                          <ul className="list-disc ml-2 p-2">
                            <li>
                              At Unity we strive to provide the best Unity
                              experience possible, there's lot's of avenues we
                              pursue this in and one of them is through
                              evaluating and purchasing Unity
                            </li>
                            <li>
                              {" "}
                              if you're a new or existing customer you can get
                              in touch with a Unity Account Manager who will be
                              your personal point of contact at Unity
                            </li>
                            <li>
                              We look to interact will all different types of
                              developers, new or veteran Unity users
                            </li>
                            <li>
                              we also want to hear from any industry looking to
                              utilize Unity for whatever project you have
                              planned
                            </li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                    <button
                      type="button"
                      className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                      data-hs-overlay="#hs-scroll-inside-body-modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-up">
              <img
                className="w-full object-cover rounded-xl"
                src="https://cdn141.picsart.com/369445816034203.jpg?to=crop&type=webp&r=231x411&q=85"
                alt="Image Description"
              />
            </div>
            <h3
              className="mt-2 text-lg font-medium text-gray-800 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white"
              data-hs-overlay="#hs-scroll-inside-viewport-modal"
            >
              Living Spaces creates a unified experience across the customer
              journey.
            </h3>

            <div
              id="hs-scroll-inside-viewport-modal"
              className="hs-overlay hidden w-full h-full fixed top-0 start-0 z-[60] overflow-x-hidden overflow-y-auto"
            >
              <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
                <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                  <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                    <h3 className="font-bold text-gray-800 dark:text-white">
                      Living Spaces creates a unified experience across the
                      customer journey.
                    </h3>
                    <button
                      type="button"
                      className="flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                      data-hs-overlay="#hs-scroll-inside-viewport-modal"
                    >
                      <span className="sr-only">Close</span>
                      <svg
                        className="flex-shrink-0 w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="p-4 overflow-y-auto">
                    <div className="space-y-4">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                          Who is ARMY?
                        </h3>
                        <p className="mt-1 text-gray-800 dark:text-gray-400">
                          <ul className="list-disc ml-2 p-2">
                            <li>
                              One of the many things they like about the
                              platform is the ease of use.
                            </li>
                            <li>
                              Like every support manager, we want the team to
                              spend more time fixing the customers problems,
                              learning, and engaging with the customer.
                            </li>
                            <li>
                              We don't want the tools to override that the tools
                              should be helping them.
                            </li>
                            <li>
                              Teammates can now transfer ownership of
                              conversations to a team in another region during
                              shift handover periods and leave notes to ensure a
                              smooth transition and a consistent customer
                              experience for the customer.
                            </li>
                            <li>
                              The team's first-response time came back down to
                              between two and three minutes.
                            </li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                    <button
                      type="button"
                      className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                      data-hs-overlay="#hs-scroll-inside-viewport-modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div
              className="aspect-w-16 aspect-h-9"
              data-aos="fade-up"
              data-aos-duration="3000"
            >
              <img
                className="w-full object-cover rounded-xl"
                src="https://cdn140.picsart.com/513bd423-605a-4a54-85c3-c4225d40a188/391013408022203.jpg?to=crop&type=webp&r=697x427&q=85"
                alt="Image Description"
              />
            </div>
            <h3
              className="mt-2 text-lg font-medium text-gray-800 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white"
              data-hs-overlay="#hs-toggle-between-modals-first-modal"
            >
              Atlassian powers sales and support at scale with BTS Army Store.
            </h3>

            <div
              id="hs-toggle-between-modals-first-modal"
              className="hs-overlay hidden w-full h-full fixed top-0 start-0 z-[60] overflow-x-hidden overflow-y-auto pointer-events-none"
            >
              <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
                <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                  <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                    <h3 className="font-bold text-gray-800 dark:text-white">
                      Atlassian powers sales and support at scale with BTS Army
                      Store.
                    </h3>
                    <button
                      type="button"
                      className="flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                      data-hs-overlay="#hs-toggle-between-modals-first-modal"
                      data-hs-overlay-close
                    >
                      <span className="sr-only">Close</span>
                      <svg
                        className="flex-shrink-0 w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="p-4 overflow-y-auto">
                    <p className="mt-1 text-gray-800 dark:text-gray-400">
                      Plan your work for long-term period, save planned time
                      estimates for major tasks and monitor deviations from plan
                    </p>
                  </div>
                  <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700"></div>
                </div>
              </div>
            </div>

            <div
              id="hs-toggle-between-modals-second-modal"
              className="hs-overlay hidden w-full h-full fixed top-0 start-0 z-[60] overflow-x-hidden overflow-y-auto pointer-events-none"
            >
              <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
                <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                  <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                    <h3 className="font-bold text-gray-800 dark:text-white">
                      <NavLink to="/orders"> Order</NavLink>
                    </h3>
                    <button
                      type="button"
                      className="flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                      data-hs-overlay="#hs-toggle-between-modals-second-modal"
                      data-hs-overlay-close
                    >
                      <span className="sr-only">Close</span>
                      <svg
                        className="flex-shrink-0 w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="aspect-w-16 aspect-h-9"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src="https://cdn131.picsart.com/274473375012201.jpg?to=crop&type=webp&r=496x496&q=85"
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <NavLink to={"/aboutus"}>
            {" "}
            <a className="group block" href="#">
              <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
                <img
                  className="w-full object-cover rounded-xl"
                  src={grow14}
                  alt="Image Description"
                />
              </div>
              <h3 className="mt-2 text-lg font-medium text-gray-800 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
                Everything you need to know about BTS Store Pro.
              </h3>
            </a>
          </NavLink>
          {/* <!-- End Card --> */}

          <a
            className="group pt-[120%] sm:pt-[90%]  relative flex flex-col w-full min-h-[15rem] bg-center bg-cover rounded-xl hover:shadow-lg transition bg-[url('https://i.pinimg.com/736x/12/cb/e9/12cbe97b727481f1e5fd08486abcaa06.jpg')]"
            href="#"
            data-aos="fade-up"
            data-aos-anchor-placement="center-bottom"
          >
            <div className="flex-auto p-4 md:p-6 ">
              <h3 className="text-xl text-pink-900/[.9] group-hover:text-slate-800 font-semibold">
                <span className="font-bold">BTS</span> Bangtan Sonyeondan also known
                as the Bangtan Boys , is a South Korean boy band formed in 2010.
                The band consists of Jin, Suga, J-Hope, RM, Jimin, V, and
                Jungkook, who co-write or co-produce much of their material
              </h3>
            </div>
            <div className="pt-0 p-4 md:p-6"></div>
          </a>

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow22}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-up">
              <img
                className="w-full object-cover rounded-xl"
                src={grow23}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow24}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow31}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block lg:-mt-28" href="#">
            <div
              className="aspect-w-16 aspect-h-9"
              data-aos="fade-up"
              data-aos-duration="3000"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={gbts1}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2 lg:mt-6"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={gbts2}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow32}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow33}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block  lg:mt-1" href="#">
            <div
              className="aspect-w-16 aspect-h-9"
              data-aos="fade-up"
              data-aos-duration="3000"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow41}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2 lg:mt-8"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow411}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow42}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-down">
              <img
                className="w-full object-cover rounded-xl"
                src={grow43}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-left">
              <img
                className="w-full object-cover rounded-xl"
                src={grow44}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-down">
              <img
                className="w-full object-cover rounded-xl"
                src={grow51}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2 lg:mt-6"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow511}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block  lg:mt-1" href="#">
            <div
              className="aspect-w-16 aspect-h-9"
              data-aos="fade-up"
              data-aos-duration="3000"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow52}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2 lg:mt-8"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow522}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-down">
              <img
                className="w-full object-cover rounded-xl"
                src={grow53}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2 lg:mt-8"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow533}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-down">
              <img
                className="w-full object-cover rounded-xl"
                src={grow54}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2 lg:mt-8"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow544}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9 lg:-mt-8" data-aos="fade-left">
              <img
                className="w-full object-cover rounded-xl"
                src={grow61}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9 lg:-mt-24" data-aos="fade-right">
              <img
                className="w-full object-cover rounded-xl"
                src={grow62}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-left">
              <img
                className="w-full object-cover rounded-xl"
                src={grow63}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}

          {/* <!-- Card --> */}
          <a className="group block" href="#">
            <div className="aspect-w-16 aspect-h-9" data-aos="fade-down">
              <img
                className="w-full object-cover rounded-xl"
                src={grow64}
                alt="Image Description"
              />
            </div>
            <div
              className="aspect-w-16 aspect-h-9 mt-2"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <img
                className="w-full object-cover rounded-xl"
                src={grow644}
                alt="Image Description"
              />
            </div>
          </a>
          {/* <!-- End Card --> */}
        </div>
        {/* <!-- End Grid --> */}
      </div>
      {/* <!-- End Card Blog --> */}
      <div className="md:max-w-2xl md:mx-auto">
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
    <div className="space-y-2">
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg1} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg2} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg3} alt="Image Description"/>
    </div>
    <div className="space-y-2">
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg4} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg5} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg6} alt="Image Description"/>
    </div>
    <div className="space-y-2">
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg7} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg8} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg9} alt="Image Description"/>
    </div>
    <div className="space-y-2">
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg10} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg11} alt="Image Description"/>
      <img className="w-full sm:w-40 h-40 object-cover transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300" src={newg12} alt="Image Description"/>
    </div>
  </div>
</div>
      <footer>
        <div className="max-w-[85rem] py-10 px-4 sm:px-6 lg:px-8 mx-auto bg-purple-700 ">
          {/* <!-- Grid --> */}
          <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-5 text-center">
            <div>
              <div
                className="hover:scale-105 transition-transform duration-500 ease-in-out rounded-tl-3xl rounded-br-3xl w-full object-cover text-center border-2 p-1  border-purple-400 "
                data-aos="zoom-in"
              >
                <img
                  className="rounded-tl-xl rounded-br-xl border-2  border-blue-400 hover:border-purple-400  sm:w-48 sm:h-48 lg:w-60 lg:h-60 mx-auto translate-y-2 hover:scale-105 transition-transform duration-500 ease-in-out w-full object-cover"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMmiau04xpdhBmGom7KwL474Gw9b1-F5-3pQ&usqp=CAU"
                  alt="Image Description"
                />
              </div>
            </div>
            {/* <!-- End Col --> */}

            <ul className="text-center" data-aos="zoom-out-down">
              <li className="inline-block relative pr-8 last:pr-0 last-of-type:before:hidden before:absolute before:top-1/2 before:right-3 before:-translate-y-1/2 before:content-['/'] before:text-gray-300 dark:before:text-gray-600">
                <NavLink to="/aboutus">
                  {" "}
                  <a
                    className="inline-flex gap-x-2 text-sm text-white hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
                    href="#"
                  >
                    About Us
                  </a>
                </NavLink>
              </li>
              <li className="inline-block relative pr-8 last:pr-0 last-of-type:before:hidden before:absolute before:top-1/2 before:right-3 before:-translate-y-1/2 before:content-['/'] before:text-gray-300 dark:before:text-gray-600" >
                <NavLink to="/gallery">
                  {" "}
                  <a
                    className="inline-flex gap-x-2 text-sm text-white hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
                    href="#"
                  >
                    Gallery
                  </a>{" "}
                </NavLink>
              </li>
            </ul>
            {/* <!-- End Col --> */}

            {/* <!-- Social Brands --> */}
            <div className="-ml-3 lg:ml-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15551.135153652767!2d77.5545749!3d12.9856763!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3df485b9a8bf%3A0xf28a75e7f8eb2569!2sOZEO%20IT%20BUSINESS%20SERVICES%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1701418727636!5m2!1sen!2sin"
                width="400"
                height="300"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
              ></iframe>
            </div>
            {/* <!-- End Social Brands --> */}
          </div>
          {/* <!-- End Grid --> */}
        </div>
      </footer>
      <BackToTop />
    </div>
  );
};

export default Gallery;
